const FontFamily = [
    {
        text: '华文宋体', value: '华文宋体', callback: () => {
        }
    },
    {
        text: '方正小标宋简体', value: '方正小标宋简体', callback: () => {
        }
    },
    {
        text: '华文仿宋', value: '华文仿宋', callback: () => {
        }
    },
    {
        text: '华文楷体', value: '华文楷体', callback: () => {
        }
    }
]
export default FontFamily;